module.exports = __webpack_public_path__ + "img/20190515402019031320cptu2.efeb0a7a.jpg";